import { FileAttachment, TextDirection } from 'interface/index';
export interface __OptionProps {
    items: __OptionItemType[];
    label?: string;
    icon?: string;
    value?: __OptionItemType[];
    counter?: number;
    hint?: string;
    image?: FileAttachment;
    vertical?: boolean;
    optionsTitle?: string;
    required?: boolean;
    multiSelect?: boolean;
    hasBorder?: boolean;
    buttonStyle?: __OptionButtonType;
    labelColor?: string;
    color?: string;
    dir?: TextDirection;
    next?: () => void;
    defaultValue?: __OptionItemType[];
    onChange?: (e?: __OptionItemType[]) => void;
    onTextChange?: (e?: string) => void;
}

export interface __OptionRef {
    getValue: () => __OptionItemType[] | null;
    setError: (text: string) => void;
}
export interface __OptionItemType {
    title: string;
    payload: number;
    value?: string | number;
    image?: FileAttachment;
    order?: number;
    isHidden?: boolean;
    archive?: boolean;
}

export enum __OptionButtonType {
    check = 'check',
    radio = 'radio',
}
